import { Bug, LayoutGrid, ListChecks, ShieldCheck, TestTube2 } from 'lucide-react'
import './projectTabs.css'

// The project's top-level tab set, shared by both layouts that render it — ProjectOverview in the full
// app and ProjectDetail in the embed — so a tab added to one cannot quietly go missing from the other.
// That drift is real history: Security was added to the embed's tabs while the full app had no tab bar
// to add it to.
//
// Explorations remains reachable by deep link without a navigation tab.
export function projectTabs({ openBugCount, securityEnabled, playwrightEnabled, siteMapEnabled = false, continuousTesting = false }: {
  continuousTesting?: boolean
  openBugCount: number
  /** Security only exists once the project runs the security polish pass. */
  securityEnabled: boolean
  siteMapEnabled?: boolean
  playwrightEnabled: boolean
}) {
  return [
    { id: 'overview', label: 'Overview', icon: <LayoutGrid size={16} /> },
    { id: 'bugs', label: 'Bugs', icon: <Bug size={16} />, badge: openBugCount },
    ...(siteMapEnabled ? [{ id: 'site-map', label: 'Site map', icon: <LayoutGrid size={16} /> }] : []),
    { id: 'test-runs', label: 'Test Runs', icon: <ListChecks size={16} /> },
    ...(playwrightEnabled ? [{ id: 'playwright-tests', label: 'Playwright Tests', icon: <TestTube2 size={16} /> }] : []),
    ...(securityEnabled && !continuousTesting ? [{ id: 'security', label: 'Security', icon: <ShieldCheck size={16} /> }] : []),
  ]
}
